import { render, staticRenderFns } from "./SettingEntryColumns.vue?vue&type=template&id=8a8736f0"
import script from "./SettingEntryColumns.vue?vue&type=script&lang=js"
export * from "./SettingEntryColumns.vue?vue&type=script&lang=js"
import style0 from "./SettingEntryColumns.vue?vue&type=style&index=0&id=8a8736f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports